export const getEmpresasDePersona = (state) => {
    return state.empresas
}